<template>
  <v-dialog v-model="add_item_modal" max-width="1300" persistent>
    <v-card :loading="loading">
      <v-card-title>Add Item</v-card-title>
      <v-card-text>
        <v-form>
          <v-row dense class="mb-1">
            <v-col cols="2" style="max-width: 12%;">
                <v-select
                  :items="item_type_list"
                  v-model="form_data.item_type"
                  dense
                  @change="changeItemType()"
                  :error-messages="form_error.item_type"
                  :hide-details="!form_error.item_type"
                  
                ></v-select>
              <!-- <v-radio-group
                v-model="form_data.item_type"
                row
                dense
                hide-details
                class="pa-0 ma-0 mt-1"
                @change="changeItemType()"
              >
                <v-radio
                  label="Item"
                  value="item"
                  class="pa-0 ma-0 radio-margin"
                ></v-radio>
                <v-radio
                  label="Stone"
                  value="stone"
                  class="pa-0 ma-0 radio-margin"
                  
                ></v-radio>
              </v-radio-group> -->
            </v-col>
            <v-col cols="3">
              <v-text-field
                :label="(form_data.item_type == 'stone')? 'Stone Name': (form_data.item_type == 'job') ? 'Job Name' : 'Item Name' "
                dense
                autofocus
                v-model="form_data.item_name"
                :error-messages="form_error.item_name"
                :hide-details="!form_error.item_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-autocomplete 
                  v-model="form_data.item_group"
                  dense
                  :items="item_groups"
                  :error-messages="form_error.item_group"
                  :hide-details="!form_error.item_group"
                  label="Group"
                  :search-input.sync="group_search_value"
                  :menu-props="{closeOnContentClick:true}"
                >
                  <template v-slot:no-data>
                      <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Group Found!</span> <span @click="addGroup" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                  </template>
                </v-autocomplete>
              </v-col>
            <!-- <v-col cols="3" v-if="form_data.item_type == 'item'">
                <v-autocomplete
                  v-model="form_data.item_group"
                  dense
                  :items="item_groups"
                  :error-messages="form_error.item_group"
                  :hide-details="!form_error.item_group"
                  label="Group"
                  :search-input.sync="group_search_value"    
                  :menu-props="{closeOnContentClick:true}"            
                >
                  <template v-slot:no-data>
                     <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Group Found!</span> <span @click="addGroup" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3" v-if="form_data.item_type == 'stone'">
                <v-autocomplete 
                  v-model="form_data.item_group"
                  dense
                  :items="stone_groups"
                  :error-messages="form_error.item_group"
                  :hide-details="!form_error.item_group"
                  label="Group"
                  :search-input.sync="group_search_value"
                  :menu-props="{closeOnContentClick:true}"
                >
                  <template v-slot:no-data>
                      <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Group Found!</span> <span @click="addGroup" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                  </template>
                </v-autocomplete>
              </v-col> -->
              <v-col cols="2">
              <v-text-field
                label="Short Code"
                v-mask="'XXXXX'"
                class="capitalize-whole-letter"
                dense
                autofocus
                v-model="form_data.short_name"
                :error-messages="form_error.short_name"
                :hide-details="!form_error.short_name"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col class="d-flex justify-end">
                 <v-switch
                  class="pt-0 ma-0"
                  dense=""
                  v-model="form_data.item_salestaxable"
                  label="Taxable"
                  color="success"
                  hide-details
                ></v-switch>
              <v-switch
                class="pt-0 ma-0"
                v-model="form_data.item_active"
                label="Active"
                color="success"
                dense=""
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense="" class="mb-0">
            <v-col cols="1">
                <v-text-field 
                  dense
                  v-model="form_data.dimension_l"
                  :error-messages="form_error.dimension_l"
                  :hide-details="!form_error.dimension_l"
                  label="L"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  dense
                  v-model="form_data.dimension_w"
                  :error-messages="form_error.dimension_w"
                  :hide-details="!form_error.dimension_w"
                  label="W"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  dense
                  v-model="form_data.dimension_h"
                  :error-messages="form_error.dimension_h"
                  :hide-details="!form_error.dimension_h"
                  :disabled="form_data.item_type == 'stone'"
                  label="H"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  dense
                  v-model="form_data.dimension_d"
                  :error-messages="form_error.dimension_d"
                  :hide-details="!form_error.dimension_d"
                  label="D"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="green-background-input">
                <v-text-field
                  dense
                  v-model="calculate_sq_ft"
                  :error-messages="form_error.sq_ft"
                  :hide-details="!form_error.sq_ft"
                  label="Sq. Ft"
                  readonly=""
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  v-model="form_data.item_color"
                  dense
                  :items="item_colors"
                  :error-messages="form_error.item_color"
                  :hide-details="!form_error.item_color"
                  label="Color"
                  :search-input.sync="search_color_name"
                  :menu-props="{closeOnContentClick:true}"
                >
                  <template v-slot:no-data>
                      <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Color Found!</span> <span @click="addColor" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  v-model="form_data.item_uom"
                  dense
                  :items="item_uom"
                  :error-messages="form_error.item_uom"
                  :hide-details="!form_error.item_uom"
                  label="UOM"
                  no-data-text="No UOM Found!"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" class="less-space"></v-col>
              <v-col class="d-flex justify-end">
                <v-switch
                  class="pt-0 ma-0"
                  dense=""
                  v-model="form_data.inventory_alert"
                  label="Inventory Alert"
                  color="success"
                  hide-details
                ></v-switch>
              </v-col>
          </v-row>
          <v-row dense="" class="mb-0">
            <v-col cols="10">
              <v-row dense="" class="primary">
                <v-col cols="4" class="d-flex align-center">
                  <span class="white--text">Vendor</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end" style="min-width:12%">
                  <span class="white--text">Px. Inv</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end" style="min-width:12%">
                  <span class="white--text">Px. Del</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end" style="min-width:12%">
                  <span class="white--text">Px. Sal</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-center" style="max-width:13%">
                  <span class="white--text">Px. Override</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end" style="min-width:12%">
                  <span class="white--text">Price</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-center" style="max-width:5%">
                  <v-icon @click="addRemoveVendor('yes')">mdi-plus-circle</v-icon>
                </v-col>
              </v-row>
              <v-row dense v-for="(vendor_data, index) in selected_vendors" :key="vendor_data.vendor_id">
                <v-col cols="4">
                  <v-autocomplete
                    dense
                    v-model="vendor_data.vendor_id"
                    :items="vendor_list"
                    :error-messages="form_error['vendors.'+index+'.vendor_id']"
                    :hide-details="!form_error['vendors.'+index+'.vendor_id']"
                    no-data-text="No Vendor Found!"
                    :disabled="vendor_data.is_system_vendor"
                  >
                    <template v-slot:no-data>
                        <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Vendor Found!</span> <span @click="addVendor" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="1" style="min-width:12%">
                  <v-text-field
                    dense
                    v-model="vendor_data.invoice_price"
                    hide-details
                    reverse
                  ></v-text-field>
                </v-col>
                <v-col cols="1" style="min-width:12%">
                  <v-text-field
                    dense
                    v-model="vendor_data.deliver_price"
                    hide-details
                    reverse
                     @input="calculateSalesPrice(index)"
                     
                  ></v-text-field>
                </v-col>
                <v-col cols="1" style="min-width:12%">
                    <v-text-field                      
                      dense
                      v-model="vendor_data.sales_price"
                      hide-details
                      readonly=""
                      class="green-background-input"
                      reverse
                    ></v-text-field>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-center" style="max-width:13%">
                  <v-switch
                    v-model="vendor_data.price_override"
                    color="success"
                    hide-details
                    dense=""
                    class="pa-0 ma-0 mt-1"
                  ></v-switch>
                </v-col>
                <v-col cols="1" style="min-width:12%">
                  <v-text-field
                    v-if="vendor_data.price_override"
                    dense
                    autofocus
                    v-model="vendor_data.override_price"
                    hide-details
                    reverse
                  ></v-text-field>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-center" style="max-width:5%">
                  <v-icon v-if="!vendor_data.is_system_vendor" @click="addRemoveVendor('no',index)">mdi-close-circle</v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2">
              <v-row dense="">
                <v-col cols="12">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                     <v-text-field 
                        dense
                        v-model="form_data.opening_stock"
                        label="Opening Stock"
                      ></v-text-field>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                       <v-text-field 
                        dense
                        v-model="form_data.order_qty"
                        label="Order Qty"
                      ></v-text-field>
                  </v-card>
                </v-col>
                <!-- <v-col cols="12">
                   <v-text-field 
                        dense
                        v-model="form_data.sold"
                        label="Sold"
                    ></v-text-field>
                </v-col> -->
                <v-col cols="12">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                   <v-text-field 
                        dense
                        v-model="form_data.lost"
                        label="Lost"
                    ></v-text-field>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense="" class="mb-1">
            <v-col cols="10" class="grey lighten-1">
              <v-row dense="" class="mt-1">
                <v-col cols="2" style="max-width:14%">
                  <v-checkbox
                    hide-details=""
                    dense=""
                    v-model="form_data.on_sale"
                    label="On Sale"
                    class="pa-0 ma-0 pt-1"
                  ></v-checkbox>
                </v-col>
                <v-col cols="2" v-if="form_data.on_sale">
                  <v-text-field
                    dense
                    v-model="form_data.discount"
                    type="number"
                    label="Discount (%)"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="2" v-if="form_data.on_sale">
                  <v-menu
                    v-model="start_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form_data.start_date"
                        label="Start Dt"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="start_date = false; parseDate()"
                      no-title
                      scrollable
                      :min="todayDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2" v-if="form_data.on_sale">
                  <v-menu
                    v-model="end_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form_data.end_date"
                        label="End Dt"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="end_date = false; parseDate2()"
                      no-title
                      scrollable
                      :min="todayDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col cols="9" class="d-flex align-center justify-center grey lighten-1">
              <span class="">On Sale: 100</span> 
              <span class="pl-6">Discount: 100</span>
              <span class="pl-6">Start Date: 10/12/2020</span>
              <span class="pl-6"> Date: 25/12/2020</span>
            </v-col> -->
          </v-row>
          <v-row dense="" class="mb-0">
            <!-- <v-col cols="3">
              <v-file-input
                label="Image(s)"
                v-model="form_data.p_image"
                dense
                :error-messages="form_error.product_image"
                :hide-details="!form_error.product_image"
                append-icon=" "
                counter
                multiple
              ></v-file-input>
            </v-col> -->
            <v-col cols="9">
              <v-text-field
                dense
                class="pt-1"
                v-model="form_data.weblink"
                :error-messages="form_error.weblink"
                :hide-details="!form_error.weblink"
                label="Web Link"
              ></v-text-field>
            </v-col>
            <v-col cols="1"></v-col>
            <!-- <v-col cols="2">
               <v-text-field 
                  dense
                  label="In Stock"
                  v-model="calculate_in_stock"
                  readonly
                ></v-text-field>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn  color="primary" @click="saveItem()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "../../plugins/axios";
import { mapState,mapMutations } from "vuex";
const moment = require('moment');
export default {
  name: "ProjectAdd",
  data() {
    return {
      loading: false,
      form_data: {
        price_override: false,
        inventory_alert: false,
        auto_reorder: false,
        item_type: '',
        taxable: true,
        item_active: true,
        item_salestaxable: false,
        on_sale: false,
        item_uom: 17,
        opening_stock :0,
        order_qty: 0,
        // sold:0,
        lost:0,
      },
      setting_data: {},
      selected_vendors: [{
        vendor_id: this.get_system_vendor,
        invoice_price: null,
        deliver_price: null,
        sales_price: null,
        override_price: null,
        price_override: true,
        is_system_vendor: true
      }],
      vendor_search: null,
      vendor_loading : false,
      start_date: false,
      end_date: false,
      form_error: {},
      vendor_list: [],
      item_colors: [],
      item_groups: [],
      item_type_list:[
        { text: "Item", value: "item" },
        { text: "Stone", value: "stone" },
        { text: "Job", value: "job" }
      ],
      // stone_groups: [],
      item_uom: [],
      group_name_error: '',
      group_name: '',
      color_name_error: '',
      color_name: '',
      group_search_value: '',
      search_color_name: ''
    };
  },
  watch: {
    add_item_modal: {
      handler(val) {
         console.log('itemmmmmmmmmmm');
        if (val) {
         
          this.getVendors();
          this.getItemColors();
          this.getItemGroup();
          this.getLogItemUom();
          this.form_data = {
            price_override: false,
            inventory_alert: false,
            auto_reorder: false,
            item_type: '',
            taxable: false,
            item_active: true,
            item_salestaxable: false,
            on_sale: false,
            item_uom: 17
          }
          this.selected_vendors = [{
            vendor_id: this.get_system_vendor,
            invoice_price: null,
            deliver_price: null,
            sales_price: null,
            override_price: null,
            price_override: true,
            is_system_vendor: true
          }]
          this.getItemSettings();
        }
      },
    }
  },
  computed: {
    ...mapState("item", ["add_item_modal"]),
    get_system_vendor() {
      let system_vendor = this.vendor_list.filter((item) => {
        if(item.is_system_vendor) {
          return item
        }
      })[0].value
      return system_vendor
    },
    todayDate() {
      return moment().format("YYYY-MM-DD");
    },
    calculate_sq_ft() {
      if(this.form_data.dimension_l && this.form_data.dimension_w && this.form_data.item_type == 'stone') {
        let sq_ft = (this.form_data.dimension_l * this.form_data.dimension_w) / 144
        return sq_ft.toFixed(2)
      } else {
        return ''
      }
    },
    // calculate_in_stock(){
    //     return parseFloat(this.form_data.opening_stock ? this.form_data.opening_stock : 0) + parseFloat(this.form_data.order_qty ? this.form_data.order_qty :0) - 
    //     parseFloat(this.form_data.sold ? this.form_data.sold : 0) - parseFloat(this.form_data.lost ? this.form_data.lost : 0)
    //   },
  },

  methods: {
    ...mapMutations("item",['setItemData']),
    calculateSalesPrice(index) {
      let invoice_price = parseFloat(this.selected_vendors[index].deliver_price);
      // console.log(invoice_price)
      // console.log(this.setting_data)
      console.log('sales_price',this.form_data.item_salestaxable)
      if(invoice_price > 0) {
        let sales_price = invoice_price + parseFloat(((invoice_price * this.setting_data.sales_tax)/100)) + parseFloat(((invoice_price * this.setting_data.finance_cost)/100)) + parseFloat(((invoice_price * this.setting_data.markup)/100)) + parseFloat(this.setting_data.delivery_cost);
        this.selected_vendors[index].sales_price = sales_price.toFixed(2)
      } else {
        this.selected_vendors[index].sales_price =  null
      }
    },
    changeItemType() {
      if(this.form_data.item_type == 'item') {
        this.form_data.item_uom = 17
      } else {
        this.form_data.item_uom = 19
      }
      this.form_data.dimension_h = ''
    },
    parseDate() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data.start_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDate2() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data.end_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    addVendor() {
      this.$router.push({ path: "/vendors" });
    },
    addRemoveVendor(is_add,index) {
      if(is_add == 'no') {
        this.selected_vendors.splice(index, 1);
      } else {
        this.selected_vendors.push({
          vendor_id: null,
          invoice_price: null,
          deliver_price: null,
          sales_price: null,
          override_price: null,
          price_override: true,
          is_system_vendor: false 
        })
      }
    },
    addGroup() {
      this.group_name_error = '';
      let _self = this;
      _self.loading = true;
      let item_type_flag = false
      if(this.form_data.item_type == 'stone') {
        item_type_flag = true
      }
      axios
        .post("add_item_group", {group_name: this.group_search_value, item_type: item_type_flag})
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.group_name_error = data.errors[key][0];
            }
          } else {
            _self.group_name = ''
            if(_self.form_data.item_type == 'stone') {
              _self.stone_groups.push({value:data.data.invoice_group_id, text: data.data.name})
            } else {
              _self.item_groups.push({value:data.data.invoice_group_id, text: data.data.name})
            }
            _self.form_data.item_group = data.data.invoice_group_id
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          _self.loading = false;
        });
    },
    addColor() {
    
      this.color_name_error = '';
      let _self = this;
     _self.loading = true;
      axios
        .post("add_item_color", {color_name: this.search_color_name})
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.color_name_error = data.errors[key][0];
            }
          } else {
            _self.color_name = ''
            _self.item_colors.push({value:data.data.icolor_id, text: data.data.icolor_title})
            _self.form_data.item_color = data.data.icolor_id
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          _self.loading = false;
        });
    },
    saveItem() {
    
      this.form_error = {};
      let _self = this;
      _self.loading = true;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      let formData = new FormData();
      for (let key in serverData) {
        formData.append(key, serverData[key]);
      }
      if (this.form_data.p_image) {
        for (let key3 in this.form_data.p_image) {
          formData.append(`product_image[${key3}]`, this.form_data.p_image[key3]);
        }
      }
      if(this.selected_vendors) {
        for (let key4 in this.selected_vendors) {
          formData.append(`vendors[${key4}][vendor_id]`, this.selected_vendors[key4]['vendor_id']);
          formData.append(`vendors[${key4}][invoice_price]`, this.selected_vendors[key4]['invoice_price']);
          formData.append(`vendors[${key4}][deliver_price]`, this.selected_vendors[key4]['deliver_price']);
          formData.append(`vendors[${key4}][sales_price]`, this.selected_vendors[key4]['sales_price']);
          formData.append(`vendors[${key4}][override_price]`, this.selected_vendors[key4]['override_price']);
          formData.append(`vendors[${key4}][price_override]`, this.selected_vendors[key4]['price_override']);
          formData.append(`vendors[${key4}][is_system_vendor]`, this.selected_vendors[key4]['is_system_vendor']);
        }
      }
      axios
        .post("add_item", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              let dataArr = key.split('.')
              if(dataArr[0] == 'product_image') {
                _self.form_error['product_image'] = 'The item image(s) must be an image';
              } else {
                _self.form_error[key] = data.errors[key][0];
              }
            }
          } else {
            _self.setItemData({ key: "add_item_modal", value: false });
            _self.setItemData({ key: "last_add_item_id", value: data.data.item_id });
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    closePopup() {
      this.setItemData({ key: "add_item_modal", value: false });
    },
    getVendors() {
      this.vendor_loading = true;
      axios
        .get("get_vendors?s=" + this.vendor_search)
        .then((response) => {
          if (response.data.status) {
            this.vendor_list = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          this.vendor_loading = false;
      });
    },
    getItemColors() {
      axios
        .get("get_item_colors")
        .then((response) => {
          if (response.data.status) {
            this.item_colors = response.data.data;
          }
        })
        .catch(function () {});
    },
    getItemGroup() {
      axios
        .get("get_item_groups")
        .then((response) => {
          if (response.data.status) {
            this.item_groups = response.data.item_group;
            // this.stone_groups = response.data.stone_group;
          }
        })
        .catch(function () {});
    },
    getLogItemUom() {
      axios
        .get("get_item_uom")
        .then((response) => {
          if (response.data.status) {
            this.item_uom = response.data.data;
          }
        })
        .catch(function () {});
    },
    getItemSettings() {
      let _self = this
      _self.loading = true
      axios.get("get_item_setting").then(response => {
        let data = response.data.data          
        for(let key in data){
          this.setting_data[key] = (data[key] == null) ? 0 : data[key]                            
        }
        _self.loading = false;
      }).catch(function(){
        _self.loading = false;
      })
    },
  },
  mounted: function () {
    this.getVendors();
  },
};
</script>
<style>
.radio-margin > .v-input--selection-controls__input {
    margin-right: 2px !important;
}
</style>